import React from "react";
import "./Blog.css";

const sections = [
  {
    title: "Moving Tips",
    posts: [
      {
        title: "The Day James Moved Without Stress",
        content:
          "James had always dreaded moving day. The last time he moved, he lost dishes, broke a TV, and spent hours arguing with a driver. This time was different. He planned early, labeled every box, and booked a reliable truck in advance. By sunset, he was sitting in his new living room, relaxed. His biggest lesson? Moving doesn't have to be chaos — with the right planning and the right transport, it can actually be easy."
      },
      {
        title: "How Amina Protected Everything She Owned",
        content:
          "Amina was relocating across Nairobi and worried about her fragile items. Instead of rushing, she spent a day properly wrapping her glassware, electronics, and furniture. When the truck arrived, everything was loaded carefully. Hours later, not a single item was damaged. Amina realized something simple: most moving disasters happen during poor packing, not on the road."
      }
    ]
  },
  {
    title: "Logistics Trends",
    posts: [
      {
        title: "How Technology is Changing Trucking in Africa",
        content:
          "Not long ago, finding a truck meant making endless phone calls and hoping someone would show up. Today, everything is changing. With platforms like Mr Truck, customers can book instantly, track drivers, and get transparent pricing. Businesses are saving time, and individuals are avoiding stress. The logistics world is moving fast — and those who embrace technology are winning."
      },
      {
        title: "The Rise of On-Demand Deliveries",
        content:
          "Peter runs a small electronics business. Before, deliveries took days to arrange. Now, he books trucks on demand and gets goods delivered the same day. His customers are happier, and his business is growing faster. This shift to instant logistics is becoming the new normal — speed is no longer a luxury, it's an expectation."
      }
    ]
  },
  {
    title: "Business Guides",
    posts: [
      {
        title: "How One SME Cut Delivery Delays in Half",
        content:
          "A small furniture business struggled with late deliveries and unhappy customers. After switching to a structured logistics system, everything changed. They scheduled deliveries properly, chose the right truck sizes, and tracked every shipment. Within weeks, delays dropped by over 50%. The lesson? Logistics isn't just transport — it's a core part of customer satisfaction."
      },
      {
        title: "Choosing the Right Truck Saved Them Thousands",
        content:
          "A hardware supplier used to hire large trucks for every delivery, thinking bigger was better. But most trips didn't require that much space. After analysing their needs, they started using smaller trucks when possible. The result? Lower costs, faster deliveries, and better efficiency. Sometimes, smarter choices matter more than bigger ones."
      }
    ]
  },
  {
    title: "Cost Saving Strategies",
    posts: [
      {
        title: "The Hidden Cost of Empty Trips",
        content:
          "Many transporters lose money without realising it. After delivering goods, they return empty — wasting fuel and time. One driver changed this by accepting return loads through a logistics platform. Suddenly, every trip made money both ways. What used to be a loss became profit."
      },
      {
        title: "How Smart Planning Reduced Transport Costs",
        content:
          "A distribution company was spending too much on logistics. After reviewing their operations, they grouped deliveries by location and reduced unnecessary trips. Fuel costs dropped, efficiency improved, and profits increased. The takeaway is simple: better planning always beats spending more money."
      }
    ]
  }
];

export default function Blog() {
  return (
    <div>
      {/* PAGE HERO */}
      <div className="page-hero">
        <span className="page-hero-label">Editorial</span>
        <h1>Stories &amp; Insights</h1>
        <p>
          Real stories, practical guides, and trends from the world of
          logistics and transport across Africa.
        </p>
      </div>

      {/* ARTICLES */}
      <div className="blog-content">
        {sections.map((section, index) => (
          <div className="blog-category" key={index}>
            <div className="blog-category-header">
              <span className="blog-category-tag">{section.title}</span>
              <div className="blog-category-line" />
            </div>

            <div className="blog-grid">
              {section.posts.map((post, i) => (
                <div className="article-card" key={i}>
                  <h4>{post.title}</h4>
                  <p>{post.content}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
